import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7a418ad0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "PurchaseTokens"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__title-pre"
  }, null, -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__title"
  }, "Token Packages", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__description"
  }, "The More You Buy The Better...", -1);
});
var _hoisted_5 = {
  "class": "PurchaseTokens__item__container"
};
var _hoisted_6 = {
  "class": "PurchaseTokens__item"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "PurchaseTokens__item__image",
    src: "assets/web/payments/tokens_small.png"
  }, null, -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__info"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__info-text"
  }, "200 Tokens"), /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__description"
  }, " More than 10 Images* ")], -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__price"
  }, " $2.49 ", -1);
});
var _hoisted_10 = {
  "class": "PurchaseTokens__item__container"
};
var _hoisted_11 = {
  "class": "PurchaseTokens__item"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "PurchaseTokens__item__image PurchaseTokens__item__image--medium",
    src: "assets/web/payments/tokens_medium.png"
  }, null, -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__info"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__info-text"
  }, "600 Tokens"), /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__description"
  }, " More than 30 Images* ")], -1);
});
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__price"
  }, " $4.99 ", -1);
});
var _hoisted_15 = {
  "class": "PurchaseTokens__item__container"
};
var _hoisted_16 = {
  "class": "PurchaseTokens__item"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "PurchaseTokens__item__image PurchaseTokens__item__image--large",
    src: "assets/web/payments/tokens_large.png"
  }, null, -1);
});
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__info"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__info-text"
  }, "2500 Tokens"), /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__description"
  }, " More than 125 Images* ")], -1);
});
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__price"
  }, " $26.99 ", -1);
});
var _hoisted_20 = {
  "class": "PurchaseTokens__item__container"
};
var _hoisted_21 = {
  "class": "PurchaseTokens__item"
};
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__info--extralarge"
  }, [/*#__PURE__*/_createElementVNode("img", {
    "class": "PurchaseTokens__item__image PurchaseTokens__item__image--extralarge",
    src: "assets/web/payments/tokens_extralarge.png"
  }), /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__info-text--extralarge"
  }, "5000 Tokens"), /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__description"
  }, " More than 250 Images* ")], -1);
});
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "PurchaseTokens__item__price"
  }, " $49.99 ", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-times-circle",
    "class": "PurchaseTokens__close-button",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      _ctx.$store.commit('updateUpgradeModalMessage', null);
      _ctx.$store.commit('updateShowPurchaseTokens', false);
    })
  }), _hoisted_2, _hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createElementVNode("button", {
    "class": "PurchaseTokens__item__button",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.purchaseTokens('200_tokens');
    })
  }, "Purchase")]), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _hoisted_13, _createElementVNode("button", {
    "class": "PurchaseTokens__item__button",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.purchaseTokens('600_tokens');
    })
  }, "Purchase")]), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _hoisted_18, _createElementVNode("button", {
    "class": "PurchaseTokens__item__button",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.purchaseTokens('2500_tokens');
    })
  }, "Purchase")]), _hoisted_19]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("button", {
    "class": "PurchaseTokens__item__button--extralarge",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $options.purchaseTokens('5000_tokens');
    })
  }, "Purchase")]), _hoisted_23])]);
}